import { FunctionComponent, memo } from "react";
import { IProps } from "./anomaly-phrase-counts-value.types";
import { useInteractionQueryParameters } from "hooks-for/filters/use-interaction-query-parameters";
import { useInteractionsCount } from "hooks-for/interactions/use-interactions-counts";
import { NumericValue } from "@edgetier/client-components";
import { calculatePercentageValue } from "utilities-for/formatting/calculate-percentage-value";
import "./anomaly-phrase-counts-value.scss";

/**
 * Display how many interactions are available in chart
 * @param props.endDateTime
 * @param props.startDateTime
 * @param props.proportion      Display proportion or not
 */
const AnomalyPhraseCountsValue: FunctionComponent<IProps> = ({ endDateTime, startDateTime, proportion }) => {
    const interactionQueryParameters = useInteractionQueryParameters({
        defaults: {
            endDateTime: endDateTime,
            startDateTime: startDateTime,
        },
    });

    // Get count of interactions according to the parameters.
    const { data: allInteractionCounts } = useInteractionsCount(interactionQueryParameters);

    // Get count of interactions only by time period group
    const { data: timeRangeInteractionsCounts } = useInteractionsCount(
        {
            startDateTime: interactionQueryParameters.startDateTime,
            endDateTime: interactionQueryParameters.endDateTime,
        },
        {
            enabled: proportion,
        }
    );

    return (
        <>
            {!proportion ? (
                <>
                    {typeof allInteractionCounts === "number" && (
                        <>
                            (<NumericValue value={allInteractionCounts} />)
                        </>
                    )}
                </>
            ) : (
                <>
                    {typeof allInteractionCounts === "number" && typeof timeRangeInteractionsCounts === "number" && (
                        <>
                            (
                            <NumericValue
                                value={calculatePercentageValue(timeRangeInteractionsCounts, allInteractionCounts)}
                                options={{ minimumFractionDigits: 0, maximumFractionDigits: 1 }}
                                unit="%"
                            />
                            )
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default memo(AnomalyPhraseCountsValue);
